import React, { Component } from 'react';
import { Modal } from '../../shared-components';

class DeleteAccountModal extends Component {
  render() {
    const { toggleModal, isShow, account, onDelete } = this.props;
    return (
      <Modal handleClick={() => toggleModal(false)}>
        <div className={`delete-account-modal modal ${isShow ? 'modal-show' : 'modal-hide'}`}>
          <div className="modal-dialog">
            <div className="modal-content">
              <p>
                Are you sure you want to remove
                <b>{` ${account.name}?`}</b>
              </p>
              <div className="delete-buttons">
                <button className="btn btn-remove" onClick={onDelete}>
                  Yes, remove
                </button>
                <button className="btn btn-cancel" onClick={() => toggleModal(false)}>
                  No, do not remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
export default DeleteAccountModal;



// WEBPACK FOOTER //
// ./src/features/user-management/components/DeleteAccount.js